import React from 'react';
import styled from 'styled-components';
import {useParams} from 'react-router-dom';
import {useUpdateWorkflowSearchConditionMutation} from 'api';
import useClientUser from 'hooks/useClientUser';

type SelectSearchCondition = {
  deal_property_definition_id: string;
  deal_property_definition_field_type: string;
  deal_property_definition_checkbox_option_ids: string;
};

type Props = {
  hubspotDealSearchConditions: SelectSearchCondition[];
  setHubspotDealSearchConditions: React.Dispatch<
    React.SetStateAction<SelectSearchCondition[]>
  >;
  index: number;
};

export default ({
  hubspotDealSearchConditions,
  setHubspotDealSearchConditions,
  index,
}: Props) => {
  const {isMember} = useClientUser();
  const {workflowId} = useParams<{poolId: string; workflowId: string}>();

  const [updateWorkflowSearchCondition] =
    useUpdateWorkflowSearchConditionMutation({
      refetchQueries: ['workflowProspectPoolCountsByStatus'],
    });

  if (!isMember) return null;

  return (
    <CrossWrapper>
      <svg
        onClick={() => {
          let newFilters: SelectSearchCondition[] = [
            ...hubspotDealSearchConditions,
          ];
          newFilters = newFilters.filter(
            (item) => Object.keys(item).length !== 0,
          );
          newFilters.splice(index, 1);
          setHubspotDealSearchConditions([...newFilters]);
          updateWorkflowSearchCondition({
            variables: {
              uuid: workflowId,
              attributes: {
                hubspotDealSearchConditions: newFilters,
              },
            },
          });
        }}
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.916016 9.08366L9.08268 0.916992M0.916016 0.916992L9.08268 9.08366L0.916016 0.916992Z"
          stroke="var(--text-color-3)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </CrossWrapper>
  );
};

const CrossWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;
